import {
  EXECUTE_REPORT,
  EXECUTE_REPORT_CLEAR_DATA,
  EXECUTE_REPORT_ERROR,
  EXECUTE_REPORT_SUCCESS,
  POST_REPORTS,
  POST_REPORTS_CLEAR_DATA,
  POST_REPORTS_ERROR,
  POST_REPORTS_SUCCESS,
  REPORT_EXPORT_EXCEL,
  REPORT_EXPORT_EXCEL_CLEAR_DATA,
  REPORT_EXPORT_EXCEL_ERROR,
  REPORT_EXPORT_EXCEL_SUCCESS,
} from "./actionTypes";

const initialState = {
  loadingReports: false,
  responseReports: null,
  errorReports: null,

  loadingExecuteReports: false,
  responseExecuteReports: null,
  errorExecuteReports: null,

  loadingReportExportExcel: false,
  responseReportExportExcel: null,
  errorReportExportExcel: null,
};

const reports = (state = initialState, action) => {
  switch (action.type) {
    case POST_REPORTS:
      state = {
        ...state,
        loadingReports: true,
        responseReports: null,
        errorReports: null,
      };
      break;
    case POST_REPORTS_SUCCESS:
      state = {
        ...state,
        loadingReports: false,
        responseReports: action.payload,
        errorReports: null,
      };
      break;
    case POST_REPORTS_ERROR:
      state = {
        ...state,
        loadingReports: false,
        responseReports: null,
        errorReports: action.payload,
      };
      break;
    case POST_REPORTS_CLEAR_DATA:
      state = {
        ...state,
        loadingReports: null,
        responseReports: false,
        errorReports: null,
      };
      break;
    /////
    case EXECUTE_REPORT:
      state = {
        ...state,
        loadingExecuteReports: true,
        responseExecuteReports: null,
        errorExecuteReports: null,
      };
      break;
    case EXECUTE_REPORT_SUCCESS:
      state = {
        ...state,
        loadingExecuteReports: false,
        responseExecuteReports: action.payload,
        errorExecuteReports: null,
      };
      break;
    case EXECUTE_REPORT_ERROR:
      state = {
        ...state,
        loadingExecuteReports: false,
        responseExecuteReports: null,
        errorExecuteReports: action.payload,
      };
      break;
    case EXECUTE_REPORT_CLEAR_DATA:
      state = {
        ...state,
        loadingExecuteReports: null,
        responseExecuteReports: false,
        errorExecuteReports: null,
      };
      break;
    /////
    case REPORT_EXPORT_EXCEL:
      state = {
        ...state,
        loadingReportExportExcel: true,
        responseReportExportExcel: null,
        errorReportExportExcel: null,
      };
      break;
    case REPORT_EXPORT_EXCEL_SUCCESS:
      state = {
        ...state,
        loadingReportExportExcel: false,
        responseReportExportExcel: action.payload,
        errorReportExportExcel: null,
      };
      break;
    case REPORT_EXPORT_EXCEL_ERROR:
      state = {
        ...state,
        loadingReportExportExcel: false,
        responseReportExportExcel: null,
        errorReportExportExcel: action.payload,
      };
      break;
    case REPORT_EXPORT_EXCEL_CLEAR_DATA:
      state = {
        ...state,
        loadingReportExportExcel: null,
        responseReportExportExcel: false,
        errorReportExportExcel: null,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default reports;
